export default __webpack_public_path__ + "static/media/loyalityFR.500e5733.png";